export class requestResponse
{
  public message : string = "";
  public data : any = null;
  public status : number = 0;

  constructor(source: Partial<requestResponse>)
  {
    Object.assign(this, source);
  }
}
